// routerConfig.ts

import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CareersComponent } from './components/careers/careers.component';
import { ServicesComponent } from './components/services/services.component';
import { ContactComponent } from './components/contact/contact.component';
import { PolicyComponent } from './components/policy/policy.component';
import { CustomerComponent } from './components/customer/customer.component';
import { CloudComponent } from './components/cloud/cloud.component';
import { ChannelComponent } from './components/channel/channel.component';
import { EnterpriseComponent } from './components/enterprise/enterprise.component';
import { ProgramComponent } from './components/program/program.component';


export const appRoutes: Routes = [
  { path: '', 
    component: HomeComponent 
  },
  { path: 'home', 
    component: HomeComponent 
  },
  {
    path: 'about',
    component: AboutComponent
  },
  { path: 'dashboard',
    component: DashboardComponent
  },
  { path: 'careers',
    component: CareersComponent
  },
  { path: 'services',
    component: ServicesComponent
  },
  { path: 'contact',
    component: ContactComponent
  },
  { path: 'policy',
    component: PolicyComponent
  },
  { path: 'customer',
    component: CustomerComponent
  },
  { path: 'cloud',
    component: CloudComponent
  },
  { path: 'channel',
    component: ChannelComponent
  },
  { path: 'enterprise',
    component: EnterpriseComponent
  },
  { path: 'program',
    component: ProgramComponent
  },
];
//export const appRoutes;


// WEBPACK FOOTER //
// /Users/globant/site/src/app/routerConfig.ts